/** Row-level reach of a permission. Mirrors the server's Scope. */
export type Scope = "OWN" | "TEAM" | "ORG" | "ALL";

export interface ObjectVerbs {
  view: boolean;
  create: boolean;
  edit: boolean;
  delete: boolean;
  export: boolean;
  approve: boolean;
}

/** Shape of GET /access/me. */
export interface EffectiveAccess {
  /** Role codes held, e.g. ["ORG_ADMIN"] */
  roles: string[];
  /** Highest rank held — governs which roles this user may assign. */
  rank: number;
  /** "lead.manage" -> "ORG" */
  permissions: Record<string, Scope>;
  /** "presales.leads" -> verbs */
  objects: Record<string, ObjectVerbs>;
  /** Flat list of slugs the user may view. The common case. */
  visible: string[];
}

export const NO_VERBS: ObjectVerbs = {
  view: false, create: false, edit: false, delete: false, export: false, approve: false,
};

/**
 * What an unresolved user gets. Deny-by-default: until /access/me answers, the
 * user can see nothing. The alternative — assume visible while loading — makes
 * restricted screens flash into view before disappearing.
 */
export const EMPTY_ACCESS: EffectiveAccess = {
  roles: [], rank: 0, permissions: {}, objects: {}, visible: [],
};
